import * as yup from "yup";

import { useState, useEffect, useCallback } from "react";
import { IoPlayOutline, IoReload } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import Toaster from "./../../../components/common/Toaster";
import ReactSelect from "../../../components/common/ReactSelect";

import complianceService from "../../../services/complianceService";
import moment from "moment";

const schema = yup.object();

const TaxIndexesFilter = ({ options, onFilter }) => {
  const [taxTypes, setTaxTypes] = useState([]);

  const periods = complianceService.getCORDeadlinePeriods();
  const statuses = complianceService.getCORDeadlineStatuses();

  const getYears = () => {
    let current_year = moment().add(1, "y").format("yyyy");
    let start_year = 2000;

    const options = [];

    while (current_year >= start_year) {
      options.push({
        value: current_year,
        label: current_year,
      });

      current_year -= 1;
    }

    return options;
  };

  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const fetchTaxTypes = useCallback(async (mounted) => {
    try {
      const result = await complianceService.getTaxTypesAsync();

      const items = result.map((item) => {
        const option = {};

        option["value"] = item.id;
        option["label"] = item.name;

        return option;
      });

      if (mounted) setTaxTypes(items);
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  }, []);

  const onSubmit = (info) => {
    const { tax_type, period, status } = info;
    const year = info.year && info.year !== undefined ? info.year.value : "";

    onFilter(tax_type, year, period, status);
  };

  const handleReset = () => {
    const tax_type = "";
    const year = "";
    const period = "";
    const status = "";

    onFilter(tax_type, year, period, status);
  };

  useEffect(() => {
    let mounted = true;

    fetchTaxTypes(mounted);

    return () => {
      mounted = false;
    };
  }, [fetchTaxTypes]);

  useEffect(() => {
    if (options) {
      const { tax_type, year, period, status } = options;

      if (tax_type) setValue("tax_type", tax_type);
      if (period) setValue("period", period);
      if (status) setValue("status", status);
      if (year) setValue("year", { value: year, label: year });
    }
  }, [options, setValue]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="tax-type-dropdown"
            name="tax_type"
            title="Tax Type"
            options={taxTypes}
            control={control}
            register={register("tax_type")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-2 space-x-2">
        <div className="col-span-1">
          <ReactSelect
            id="year-dropdown"
            name="year"
            title="Year"
            options={getYears()}
            control={control}
            register={register("year")}
            errors={errors}
            isClearable
          />
        </div>
        <div className="col-span-1">
          <ReactSelect
            id="period-dropdown"
            name="period"
            title="Period"
            options={periods}
            control={control}
            register={register("period")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="status-dropdown"
            name="status"
            title="Status"
            options={statuses}
            control={control}
            register={register("status")}
            errors={errors}
            isClearable
          />
        </div>
      </div>
      <div className="grid grid-cols-5 gap-2 pt-5">
        <div className="col-span-2">
          <button
            type="button"
            onClick={handleReset}
            className="button bg-gray-200 text-gray-500"
          >
            Reset <IoReload className="ml-2" />
          </button>
        </div>
        <div className="col-span-3">
          <button type="submit" className="button button-primary">
            Apply Filter <IoPlayOutline className="ml-2" />
          </button>
        </div>
      </div>
    </form>
  );
};

export default TaxIndexesFilter;
